<tt-page *ngIf="!!setting">
    <ng-container *ngIf="tabletSize.matches && itemState === 'p2updatetableedit'">
        <tt-card class="col-xs-12 col-md-9 p-5" ttHeading="h_update_tables"></tt-card>

        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-6 p-5">
                <tt-input ttRememberId="w_p2updatetables.filtervalue" ttLabel="filtervalue" ttFocus [(ttModel)]="setting.filtervalue" ttShowClearButton></tt-input>
            </tt-card>

            <tt-card class="col-xs-12 col-md-3 p-5">
                <tt-button ttText="register_new_p2_updatetable" ttTextAlign="left" ttIcon="fas fa-plus" (ttClick)="createTable($event)"></tt-button>
            </tt-card>
        </div>
    </ng-container>

    <ng-container *ngIf="!tabletSize.matches">
        <tt-card>
            <tt-input ttRememberId="w_p2updatetables.filtervalue" ttLabel="filtervalue" ttFocus [(ttModel)]="setting.filtervalue" ttShowClearButton></tt-input>
            <tt-button ttText="register_new_p2_updatetable" ttTextAlign="left" ttIcon="fas fa-plus" (ttClick)="createTable($event)"></tt-button>
        </tt-card>
    </ng-container>

    <ng-container *ngIf="!tabletSize.matches; else tabletLayout">
        <tt-list [ttData]="tables" [ttFilter]="setting.filtervalue" (ttClick)="openTable($event.item, $event.event)"></tt-list>
    </ng-container>

    <ng-template #tabletLayout>
        <ng-container *ngIf="itemState !== 'p2updatetableedit'; else inlineEditor">
            <tt-list [ttData]="tables" [ttFilter]="setting.filtervalue" (ttClick)="openTable($event.item, $event.event)"></tt-list>
        </ng-container>

        <ng-template #inlineEditor>
            <tt-divider ttRememberId="p2updatetables_dividers">
                <tt-divider-columns>
                    <tt-divider-pane ttSize="50">
                        <tt-list class="col-xs-12 p-5" [ttData]="tables" [ttFilter]="setting.filtervalue" (ttClick)="openTable($event.item, $event.event)"></tt-list>
                    </tt-divider-pane>

                    <tt-divider-pane ttSize="50">
                        <tt-p2-update-table-edit *ngIf="p2UpdateTableKeyno !== ''" class="col-xs-12 p-5" [p2UpdateTableKeyno]="p2UpdateTableKeyno" [inline]="true" (onSave)="updateList()"></tt-p2-update-table-edit>
                    </tt-divider-pane>
                </tt-divider-columns>
            </tt-divider>
        </ng-template>
    </ng-template>
</tt-page>
